import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    pointerEvents: 'none',
    zIndex: 0,
  },
  labelText: {
    fontFamily: ['Poppins', 'Roboto', 'Open Sans', 'sans-serif'].join(','),
    // fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: 14,
  },
  totalText: {
    fontFamily: ['Poppins', 'Roboto', 'Open Sans', 'sans-serif'].join(','),
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: 16,
  },
}));
